import { IconX } from "@tabler/icons-react";
import TextareaField from "../../../components/common/TextareaField";
import SelectInput from "../../../components/Select";
import InputField from "../../../components/common/InputField";
import NewSelectInput from "../../../components/NewSelectInput";
import NewinputField from "../../../components/NewInput";
import { useLanguage } from "../../../context/LanguageContext";

type SmsModalProps = {
  open: boolean;
  onClose: () => void;
  inPlace?: boolean;
};

export default function SmsModal({
  open,
  onClose,
  inPlace = false,
}: SmsModalProps) {
  const { t } = useLanguage();
  if (!open) return null;

  if (inPlace) {
    return (
      <div className="bg-white backdrop-blur-md border border-slate-200/80 shadow-sm rounded-2xl overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center px-5 py-4 border-b border-slate-100 bg-white">
          <h3 className="text-lg font-bold text-[#212121]">{t("SMS")}</h3>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={onClose}
              className="p-1.5 px-4 rounded-lg text-xs font-semibold transition-all duration-200 flex items-center justify-center gap-2 bg-[#FBD037] hover:bg-[#f7c400] text-black shadow hover:shadow-md cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {t("Send")}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition-colors text-slate-700"
            >
              <IconX size={16} />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 m-4 transition-all duration-300 space-y-3">
          <div className="grid grid-cols-2 gap-4">
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
            <NewSelectInput
              label={t("Reason")}
              className="flex items-center gap-4"
              name=""
              selectOptions={[]}
            />
            <NewinputField
              title={t("Mobile No")}
              placeholder="98521002500"
              className="flex items-center gap-4"
              name=""
            />
            <TextareaField
              rows={3}
              label={t("Message")}
              placeholder={t("Message")}
              name="message"
              className="col-span-2 flex items-center gap-2"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-end p-4">
      <div className="rounded-2xl w-full max-w-[500px] h-[calc(100vh-2rem)] flex flex-col relative bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] shadow-2xl overflow-hidden animate-in fade-in slide-in-from-right duration-300">
        {/* Header */}
        <div className="flex items-center flex-shrink-0">
          <div className="bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4 w-full rounded-tl-3xl">
            <h2 className="text-2xl font-bold">{t("SMS")}</h2>
          </div>
          <div className="relative">
            <button
              onClick={onClose}
              className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 mr-4 flex items-center justify-center flex-shrink-0 hover:bg-gray-300 transition"
            >
              <IconX size={20} />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="w-full flex-1 overflow-y-auto p-6 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] scrollbar-clean">
          <div className="bg-white p-4 rounded-xl shadow-md space-y-4">
            <SelectInput
              label={t("Select")}
              className="w-full"
              name=""
              selectOptions={[]}
            />
            <InputField
              label={t("Send Mobile Number")}
              placeholder="98521002500"
              className="w-full"
            />
            <TextareaField
              rows={5}
              label={t("Message")}
              placeholder={t("Message")}
              name="message"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-end gap-2 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex-shrink-0">
          <button
            onClick={onClose}
            className="w-full sm:w-auto h-11 px-6 rounded-full border border-[#D8D8D8] bg-white hover:bg-[#F5F5F5] transition-all duration-200 font-medium cursor-pointer"
          >
            {t("Cancel")}
          </button>
          <button
            onClick={onClose}
            className="w-full sm:w-auto min-w-[140px] h-11 px-6 rounded-full font-semibold transition-all duration-200 flex items-center justify-center gap-2 bg-[#FBD037] hover:bg-[#f7c400] text-black shadow-lg hover:shadow-xl cursor-pointer"
          >
            {t("Send")}
          </button>
        </div>
      </div>
    </div>
  );
}
